'use client';

import {
  emailOTPClient,
  genericOAuthClient,
  organizationClient,
} from 'better-auth/client/plugins';
import { createAuthClient } from 'better-auth/react';
import { getClientBaseURL } from '@/lib/auth/url-config';

export const authClient = createAuthClient({
  baseURL: getClientBaseURL(),
  plugins: [emailOTPClient(), genericOAuthClient(), organizationClient()],
});

// Export commonly used methods for convenience
export const { signIn, signOut, signUp, useSession, getSession } = authClient;

// Export email OTP methods
export const { sendVerificationOtp, verifyEmail } = authClient.emailOtp;
